import { render } from "./view_trust_form.html?vue&type=template&id=6b2b5dfc&external"
import script from "./view_trust_form.js?vue&type=script&lang=js&external"
export * from "./view_trust_form.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__